"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.parse = void 0;
const gp = __importStar(require("generic-parser"));
const error_1 = require("../../parser/cst/error");
const container_1 = require("../../node/container");
const lawID_1 = require("../../law/lawID");
const common_1 = require("./common");
const makeEnv = () => gp.makeStringEnv();
const factory = new gp.RuleFactory();
const ptnAnyLawIDInner = Object.values(lawID_1.ptnLawID).map(s => s.replace(/\(\?<\w+>/g, "(")).map(s => `(?:${s})`).join("|");
const reAnyLawID = new RegExp(`^(?:${ptnAnyLawIDInner})`);
const $lawID = factory
    .sequence(s => s
    .and(r => r
    .sequence(s => s
    .and(r => r
    .sequence(s => s
    .andOmit(r => r.regExp(reAnyLawID), "lawID")
    .action(({ lawID }) => (0, lawID_1.parseLawID)(lawID))), "lawID")
    .andOmit(r => r.assert(({ lawID }) => lawID))
    .action(({ lawID }) => lawID))));
const $fragmentLaw = factory
    .sequence(s => s
    .and(() => $lawID, "lawIDStruct")
    .and(r => r.zeroOrOne(r => r
    .sequence(s => s
    .and(r => r.seqEqual("_"))
    .and(r => r.regExp(/^\d{8}/), "date")
    .and(r => r.seqEqual("_"))
    .and(() => $lawID, "lawIDStruct")
    .action(({ date, lawIDStruct }) => ({ date, lawIDStruct })))), "revision")
    .action(({ text, lawIDStruct, revision }) => ({
    type: "LAW",
    text: text(),
    lawIDStruct,
    revision,
})));
const $equalsNum = factory
    .sequence(s => s
    .andOmit(r => r.seqEqual("="))
    // eslint-disable-next-line no-irregular-whitespace
    .and(r => r.regExp(/^[^/ 　\t]+/)));
const $suareBracketsAttr = factory
    .sequence(s => s
    // .andOmit(r => r.assert(({ offset, target }) => { console.log({ offset: offset(), target: target() }); return true; }))
    .andOmit(r => r.seqEqual("["))
    // eslint-disable-next-line no-irregular-whitespace
    .and(r => r.regExp(/^[^/ 　\t=[\]"]+/), "key")
    .andOmit(r => r.seqEqual("="))
    .and(r => r
    .sequence(s => s
    .andOmit(r => r.seqEqual("\""))
    // eslint-disable-next-line no-irregular-whitespace
    .and(r => r.regExp(/^[^/ 　\t=[\]"]+/))
    .andOmit(r => r.seqEqual("\""))), "value")
    .andOmit(r => r.seqEqual("]"))
    .action(({ key, value }) => ({ key, value })));
const $suareBracketsNth = factory
    .sequence(s => s
    .andOmit(r => r.seqEqual("["))
    .and(r => r.regExp(/^\d+/))
    .andOmit(r => r.seqEqual("]")));
const $fragmentTopLevel = factory
    .sequence(s => s
    .and(r => r.regExp(new RegExp(`^(?:${Object.keys(common_1.topLevelAlias).join("|")})`)), "topLevelKey")
    .and(r => r.zeroOrOne(() => $equalsNum), "num")
    .and(r => r.zeroOrMore(() => $suareBracketsAttr), "attr")
    .and(r => r.zeroOrOne(() => $suareBracketsNth), "nth")
    .action(({ text, topLevelKey, num, attr, nth }) => ({
    type: "TOPLEVEL",
    text: text(),
    tag: common_1.topLevelAlias[topLevelKey],
    num,
    attr,
    nth,
})));
const $fragmentArticlesContainer = factory
    .sequence(s => s
    .and(r => r.regExp(new RegExp(`^(?:${container_1.articlesContainerTags.join("|")})`)), "tag")
    .and(r => r.zeroOrOne(() => $equalsNum), "num")
    .and(r => r.zeroOrMore(() => $suareBracketsAttr), "attr")
    .and(r => r.zeroOrOne(() => $suareBracketsNth), "nth")
    .action(({ text, tag, num, attr, nth }) => ({
    type: "ARTICLES",
    text: text(),
    tag: tag,
    num,
    attr,
    nth,
})));
const $fragmentSentencesContainer = factory
    .sequence(s => s
    .andOmit(r => r.nextIsNot(r => r.regExp(new RegExp(`^(?:${Object.keys(common_1.topLevelAlias).join("|")})`))))
    .and(r => r.regExp(new RegExp(`^(?:${Object.keys(common_1.sentencesContainerAlias).join("|")})`)), "sentencesContainerKey")
    .and(r => r.zeroOrOne(() => $equalsNum), "num")
    .and(r => r.zeroOrMore(() => $suareBracketsAttr), "attr")
    .and(r => r.zeroOrOne(() => $suareBracketsNth), "nth")
    .action(({ text, sentencesContainerKey, num, attr, nth }) => ({
    type: "SENTENCES",
    text: text(),
    tag: common_1.sentencesContainerAlias[sentencesContainerKey],
    num,
    attr,
    nth,
})));
const $fragment = factory
    .choice(s => s
    .or(() => $fragmentSentencesContainer)
    .or(() => $fragmentArticlesContainer)
    .or(() => $fragmentTopLevel)
    .or(() => $fragmentLaw));
const $path = factory
    .sequence(s => s
    .and(() => $fragment, "first")
    .and(r => r.zeroOrMore(r => r
    .sequence(s => s
    .andOmit(r => r.seqEqual("/"))
    .and(() => $fragment))), "rest")
    .action(({ first, rest }) => [first, ...rest]));
const parse = (text) => {
    const m = $path.match(0, text, makeEnv());
    if (m.ok) {
        if (m.nextOffset === text.length) {
            return {
                ok: true,
                value: m.value,
            };
        }
        else {
            return {
                ok: false,
                errors: [new error_1.ErrorMessage("Cannot parse the path", [m.nextOffset, text.length])],
            };
        }
    }
    else {
        return {
            ok: false,
            errors: [new error_1.ErrorMessage("Cannot parse the path", [0, text.length])],
        };
    }
};
exports.parse = parse;
exports.default = exports.parse;
//# sourceMappingURL=parse.js.map